var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { apiCreateContactConsultationGuest } from '@/actions/ContactActions/create';
import { ContactConsultationConfirmView } from '@/components/pages/contact/consultation/ContactConsultationConfirmView/ContactConsultationConfirmView';
import Layout from '@/container/Layout';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { wrapNotifyError } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { contactConsultationCompletePath, contactConsultationConfirmPath, contactConsultationPath, contactPath, getAbsolutePath, } from '@/utils/router/links';
const title = 'コンサル選定のご相談 - 確認｜PROFFIT';
const description = 'コンサル選定に向けてヒアリングを実施し、活用のアドバイスをしながら、依頼事項を明確に整理します。';
/**
 * コンサル選定のご相談の確認ページ
 */
export const ContactConsultationConfirmPage = (props) => {
    const { formState } = props;
    const dispatch = useDispatch();
    const history = useNavigate();
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const judgeNumber = (value, judgeValue) => {
                if (value === null || typeof value === 'undefined') {
                    return false;
                }
                if (typeof value === 'string') {
                    return Number(value) === judgeValue;
                }
                return value === judgeValue;
            };
            const requestPayload = {
                json: {
                    about_meeting_tool: values.about_meeting_tool,
                    additional_information: values.additional_information,
                    budget: judgeNumber(values.budget_type, 1) ? values.budget : null,
                    budget_type: values.budget_type,
                    consideration_end_at: judgeNumber(values.consideration_type, 1)
                        ? null
                        : `${values.consideration_end_year}-${values.consideration_end_month}-01`,
                    consideration_type: values.consideration_type,
                    contactable_time_1: values.contactable_time_1,
                    contactable_time_2: values.contactable_time_2,
                    contactable_time_3: values.contactable_time_3,
                    email: values.email,
                    first_name: values.first_name,
                    first_name_kana: values.first_name_kana,
                    last_name: values.last_name,
                    last_name_kana: values.last_name_kana,
                    phone1: values.phone1,
                    phone2: values.phone2,
                    phone3: values.phone3,
                    recruitment_type: values.recruitment_type,
                    what_request: values.what_request,
                },
            };
            const action = apiCreateContactConsultationGuest(requestPayload, {});
            yield wrapDispatch(dispatch, action);
            history.push(contactConsultationCompletePath());
        }));
    }), [dispatch, history]);
    /** パンくず */
    const breadcrumbs = useMemo(() => [
        { link: contactPath(), text: 'お問い合わせ' },
        { text: 'コンサル選定のご相談' },
    ], []);
    return (_jsxs(Layout, Object.assign({ mainClassName: clsx('l-main client_mypage') }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(contactConsultationConfirmPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(ContactConsultationConfirmView, { className: 'mb-80', initialValues: formState, onSubmit: onSubmit, prevTo: contactConsultationPath() })] })));
};
